import { useState } from 'react';
import useDebouncedState from './useDebouncedState';

interface UseDebouncedSearchTermProps {
  debounceTime?: number;
  initialValue?: string;
}

interface UseDebouncedSearchTermReturn {
  setValue: (newValue: string) => void;
  immediateValue: string;
  debouncedValue: string;
}

function useDebouncedSearchTerm(props: UseDebouncedSearchTermProps = {}): UseDebouncedSearchTermReturn {
  const { debounceTime = 300, initialValue = '' } = props;

  const [immediateValue, setImmediateValue] = useState(initialValue);
  const [debouncedValue, setValueDebounced] = useDebouncedState(initialValue, debounceTime);

  const setValue = (newValue: string) => {
    setValueDebounced(newValue);
    setImmediateValue(newValue);
  };

  return { setValue, immediateValue, debouncedValue };
}

export default useDebouncedSearchTerm;
